import React from 'react';
import { FiUser, FiSearch, FiBox, FiEye, FiCheckCircle, FiLock, FiRefreshCw, FiMail, FiShield } from 'react-icons/fi';
import SEO from '../components/SEO';
import '../styles/legal.css';
import config from '../config';

const PrivacyPage = () => (
    <div className="legal-bento-container py-5">
        <SEO
            title="Privacy Policy"
            description="Privacy Policy for Electrospinning Data platform, detailing how we collect, use, and protect your information."
        />

        <header className="text-center mb-5 bento-header">
            <h1 className="display-4 font-weight-bold">Privacy Policy</h1>
            <p className="lead text-muted legal-intro-bento">
                We are committed to protecting your privacy and ensuring you have control over your data in compliance with GDPR.
            </p>
            <span className="legal-date">Effective Date: December 28, 2025</span>
        </header>

        <div className="bento-grid-legal">

            <section className="legal-tile tile-accent tile-full">
                <h2><FiShield /> 1. Data Controller</h2>
                <p className="mb-0">
                    The data controller responsible for your personal information is:
                    <br />
                    <strong>Electrospinning Data Platform</strong>
                    <br />
                    Contact: <a href={`mailto:${config.supportEmail}`}>{config.supportEmail}</a>
                </p>
            </section>

            <section className="legal-tile tile-full">
                <h2><FiSearch /> 2. Information We Collect</h2>
                <p>We collect the minimum amount of data necessary to provide our services and foster a scientific community.</p>

                <div className="row g-4 mt-2">
                    <div className="col-md-6">
                        <h3>2.1 Personal Information You Provide</h3>
                        <ul className="legal-list">
                            <li><strong>Account Information:</strong> Name, Email address, and Password.</li>
                            <li><strong>Professional Profile:</strong> Affiliation, Lab name, ORCID iD, and Country.</li>
                            <li><strong>User Content:</strong> Datasets, experiments, or comments you upload.</li>
                        </ul>
                    </div>
                    <div className="col-md-6">
                        <h3>2.2 Information Automatically Collected</h3>
                        <ul className="legal-list">
                            <li><strong>Usage Data:</strong> Pages viewed, time spent, and interaction patterns.</li>
                            <li><strong>Log Data:</strong> IP address, browser type, and operating system for security.</li>
                        </ul>
                    </div>
                </div>
            </section>

            <section className="legal-tile">
                <h2><FiBox /> 3. How We Use Your Information</h2>
                <ul className="legal-list">
                    <li><strong>Service Provision:</strong> To create and manage your account and datasets.</li>
                    <li><strong>Attribution:</strong> To correctly attribute your scientific work to you.</li>
                    <li><strong>Communication:</strong> To send important account updates and verifications.</li>
                    <li><strong>Security:</strong> To detect and prevent unauthorized activity.</li>
                </ul>
            </section>

            <section className="legal-tile">
                <h2><FiEye /> 4. Data Sharing and Visibility</h2>
                <ul className="legal-list">
                    <li><strong>Public Scientific Data:</strong> Datasets you publish are CC0 and publicly accessible.</li>
                    <li><strong>Profile Visibility:</strong> You control your profile visibility via account settings.</li>
                    <li><strong>Service Providers:</strong> We use trusted providers for hosting and email services.</li>
                    <li><strong>Legal Requirements:</strong> Disclosures required by law or to protect safety.</li>
                </ul>
            </section>

            <section className="legal-tile tile-full">
                <h2><FiCheckCircle /> 5. Your Rights (GDPR)</h2>
                <p>Under the GDPR, you have the following rights regarding your personal data:</p>
                <div className="row g-4">
                    <div className="col-md-6">
                        <ul className="legal-list">
                            <li><strong>Right to Access:</strong> Request a copy of your personal data.</li>
                            <li><strong>Right to Rectification:</strong> Update or correct your information.</li>
                            <li><strong>Right to Erasure:</strong> Request deletion of your account.</li>
                        </ul>
                    </div>
                    <div className="col-md-6">
                        <ul className="legal-list">
                            <li><strong>Restrict Processing:</strong> Limit how we use your data.</li>
                            <li><strong>Data Portability:</strong> Receive your data in a structured format.</li>
                        </ul>
                    </div>
                </div>
                <p className="mt-3 mb-0 small text-muted italic">
                    Contact us at <a href={`mailto:${config.supportEmail}`}>{config.supportEmail}</a> to exercise these rights.
                </p>
            </section>

            <section className="legal-tile">
                <h2><FiLock /> 6. Data Security</h2>
                <p className="mb-0">
                    We implement appropriate technical and organizational measures to protect your personal data. However, no method of transmission over the internet is 100% secure.
                </p>
            </section>

            <section className="legal-tile">
                <h2><FiRefreshCw /> 7. Changes to This Policy</h2>
                <p className="mb-0">
                    We may update this Privacy Policy from time to time. We will notify you of significant changes by updating the "Effective Date" above.
                </p>
            </section>

            <section className="legal-tile tile-accent tile-full text-center">
                <h2><FiMail /> 8. Contact Us</h2>
                <p className="mb-0">
                    If you have any questions about this Privacy Policy, please contact us at <a href={`mailto:${config.supportEmail}`}>{config.supportEmail}</a>.
                </p>
            </section>

        </div>
    </div>
);

export default PrivacyPage;
